module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0",
      "height": "auto !important"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "活动名称",
      "input-align": "right",
      "readonly": ""
    },
    model: {
      value: (_vm.formData.saiqu_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "saiqu_name", $$v)
      },
      expression: "formData.saiqu_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "省份/专业公司"
    },
    on: {
      "click": function($event) {
        _vm.showDanweiPicker = true
      }
    },
    model: {
      value: (_vm.formData.gongsi),
      callback: function($$v) {
        _vm.$set(_vm.formData, "gongsi", $$v)
      },
      expression: "formData.gongsi"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDanweiPicker),
      callback: function($$v) {
        _vm.showDanweiPicker = $$v
      },
      expression: "showDanweiPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.danweiColumns,
      "show-toolbar": "",
      "value-key": "name",
      "default-index": _vm.defaultDanweiIndex
    },
    on: {
      "cancel": function($event) {
        _vm.showDanweiPicker = false
      },
      "confirm": _vm.onDanweiConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.gongsi_id < 112638 && _vm.formData.gongsi_id > 112593) ? _c('div', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "分公司"
    },
    on: {
      "click": function($event) {
        _vm.showFengongsiPicker = true
      }
    },
    model: {
      value: (_vm.formData.fengongsi),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fengongsi", $$v)
      },
      expression: "formData.fengongsi"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showFengongsiPicker),
      callback: function($$v) {
        _vm.showFengongsiPicker = $$v
      },
      expression: "showFengongsiPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.fengongsiColumns,
      "show-toolbar": "",
      "value-key": "name",
      "default-index": _vm.defaultFengongsiIndex
    },
    on: {
      "cancel": function($event) {
        _vm.showFengongsiPicker = false
      },
      "confirm": _vm.onFengongsiConfirm
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '队伍名称不能为空'
      }],
      "label": "队伍名称",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入队伍名称"
    },
    model: {
      value: (_vm.formData.mingcheng),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mingcheng", $$v)
      },
      expression: "formData.mingcheng"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formData.mingcheng),
      expression: "!formData.mingcheng"
    }],
    staticClass: "operate-desc-left"
  }, [_vm._v("队伍名称不能含有英文字母哦~")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.mingcheng),
      expression: "formData.mingcheng"
    }],
    staticClass: "operate-desc-left"
  }, [_vm._v("队伍名称不能含有英文字母哦~ "), _c('br'), _vm._v("您的队伍全称是\n\n                    "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px",
      "color": "#ff9535"
    }
  }, [_vm._v(_vm._s(_vm.formData.danwei) + " " + _vm._s(_vm.formData.mingcheng) + " " + _vm._s(_vm.formData.mingcheng_end))])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍照片",
      "value": _vm.formData.heying.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.heying,
      "limit": 1,
      "name": 'heying'
    },
    on: {
      "imageListChange": _vm.heyingChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传一张队伍照片(横版),建议比例3x4")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "联系人",
      "rules": [{
        required: true,
        message: '联系人不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人姓名"
    },
    model: {
      value: (_vm.formData.lxname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lxname", $$v)
      },
      expression: "formData.lxname"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("建议联系人最好是教练员")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "联系人手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.lxphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lxphone", $$v)
      },
      expression: "formData.lxphone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "验证码",
      "rules": [{
        required: true,
        message: '请输入验证码'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入验证码"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('van-button', {
          attrs: {
            "native-type": "button",
            "size": "small",
            "type": "primary",
            "disabled": _vm.clockSecond > 0
          },
          on: {
            "click": _vm.getCode
          }
        }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
          '(' + _vm.clockSecond + 's)' : '获取验证码'))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.formData.phonecode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phonecode", $$v)
      },
      expression: "formData.phonecode"
    }
  })], 1), _vm._v(" "), (false) ? _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "教练员",
      "placeholder": "请选择教练员"
    },
    on: {
      "click": function($event) {
        _vm.showJiaolianPicker = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("如需在获奖证书出现的教练员都需要添加")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jiaolian.length > 0),
      expression: "formData.jiaolian.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.formData.jiaolian), function(jiaolian, index) {
    return _c('div', {
      key: index,
      staticClass: "memberLi"
    }, [_vm._v("\n                        第" + _vm._s((['一', '二', '三', '四', '五'])[index]) + "教练员\n                        "), _c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jiaolian.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n                        ")])], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), ([648, 751, 767].indexOf(parseInt(this.saiqu_id)) == -1) ? _c('div', [_c('van-divider', [_vm._v("发票抬头信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "0 0 10px 0"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.fapiaoPickerShow = true
      }
    }
  }, [_vm._v("选择抬头")])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '发票抬头不能为空'
      }],
      "label": "发票抬头",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.formData.fapiao_taitou),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_taitou", $$v)
      },
      expression: "formData.fapiao_taitou"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '税号不能为空'
      }],
      "label": "税号",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.formData.fapiao_shuihao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_shuihao", $$v)
      },
      expression: "formData.fapiao_shuihao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("如果您所在的单位没有纳税人识别号请填写“无”")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "地址",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方地址"
    },
    model: {
      value: (_vm.formData.fapiao_address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_address", $$v)
      },
      expression: "formData.fapiao_address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "电话",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方电话"
    },
    model: {
      value: (_vm.formData.fapiao_tel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_tel", $$v)
      },
      expression: "formData.fapiao_tel"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "开户行及账号",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方开户行及账号"
    },
    model: {
      value: (_vm.formData.fapiao_account),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_account", $$v)
      },
      expression: "formData.fapiao_account"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "备注",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.formData.fapiao_beizhu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_beizhu", $$v)
      },
      expression: "formData.fapiao_beizhu"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("不会体现在发票上，仅显示给管理员")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "接收邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接收邮箱"
    },
    model: {
      value: (_vm.formData.fapiao_email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_email", $$v)
      },
      expression: "formData.fapiao_email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "接收手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接收手机"
    },
    model: {
      value: (_vm.formData.fapiao_phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_phone", $$v)
      },
      expression: "formData.fapiao_phone"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [],
      "label": "队伍口号",
      "maxlength": "15",
      "show-word-limit": "",
      "input-align": "right",
      "autosize": "",
      "type": "textarea",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入队伍口号"
    },
    model: {
      value: (_vm.formData.kouhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "kouhao", $$v)
      },
      expression: "formData.kouhao"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍风采视频",
      "value": _vm.formData.fc_pic.length + '/1'
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('van-icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-o"
    },
    on: {
      "click": function($event) {
        return _vm.onQuestion('heying')
      }
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.fc_pic,
      "limit": 1,
      "name": 'fc_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传队伍风采视频的二维码图片")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('CaipanPicker', {
    attrs: {
      "show": _vm.showCaipanPicker,
      "limit": _vm.saiqu_id == 648 ? 2 : 1,
      "danweiId": _vm.formData.danwei_id,
      "defaultValue": _vm.formData.caipan
    },
    on: {
      "onChange": _vm.onCaipanChange,
      "onClose": function($event) {
        _vm.showCaipanPicker = false
      },
      "onConfirm": _vm.onCaipanConfirm
    }
  }), _vm._v(" "), _c('JiaolianPicker', {
    attrs: {
      "show": _vm.showJiaolianPicker,
      "limit": 5,
      "danweiId": _vm.formData.danwei_id,
      "defaultValue": _vm.formData.jiaolian
    },
    on: {
      "onChange": _vm.onJiaolianChange,
      "onClose": function($event) {
        _vm.showJiaolianPicker = false
      },
      "onConfirm": _vm.onJiaolianConfirm
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('FapiaoPicker', {
    attrs: {
      "show": _vm.fapiaoPickerShow
    },
    on: {
      "onChange": _vm.changeFapiao,
      "onClose": _vm.closeFapiao
    }
  }), _vm._v(" "), (_vm.saiqu_id == 648) ? _c('NavFloatService', {
    on: {
      "show": function($event) {
        _vm.showKefu = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    model: {
      value: (_vm.showKefu),
      callback: function($$v) {
        _vm.showKefu = $$v
      },
      expression: "showKefu"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "text-align": "center",
      "margin": "10px auto",
      "font-size": "14px"
    }
  }, [_vm._v("\n             比赛负责:孙健明 18020182507 "), _c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (18020182507),
      expression: "18020182507",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }]
  }, [_vm._v("复制")]), _c('br'), _vm._v("\n             赛事咨询:王 悠 18020182792 "), _c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (18020182792),
      expression: "18020182792",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }]
  }, [_vm._v("复制")]), _c('br'), _vm._v("\n             赛事咨询:高 翔 18020182729 "), _c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (18020182729),
      expression: "18020182729",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }]
  }, [_vm._v("复制")]), _c('br')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d93aa2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep1Dianxin.vue
// module id = 2243
// module chunks = 0